var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("table", { staticClass: "table table-sm table-hover" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.accounts, function (acc) {
                return [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "account_td", attrs: { colspan: "10" } },
                      [
                        _vm._v(
                          _vm._s(acc.login) + " (" + _vm._s(acc.ats_num) + ") "
                        ),
                        _c("strong", [_vm._v(_vm._s(acc.project_name))]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.records[acc.id], function (record, i) {
                    return _c("tr", [
                      _c("td", [_vm._v(_vm._s(i + 1))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(record.sip_login))]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: record.sip_password,
                              expression: "record.sip_password",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: record.sip_password },
                          on: {
                            change: function ($event) {
                              return _vm.updateRecord(record.id, record)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                record,
                                "sip_password",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(record.extension))]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          [
                            _c("multiselect", {
                              attrs: {
                                options: _vm.managers,
                                "track-by": "name",
                                label: "name",
                                noResult: "Пользователь не найден",
                                disabled: _vm.disabled,
                                "show-labels": false,
                                placeholder: "Выберите пользователя",
                                multiple: false,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateRecord(record.id)
                                },
                              },
                              model: {
                                value: _vm.selectedManagers[record.id],
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectedManagers, record.id, $$v)
                                },
                                expression: "selectedManagers[record.id]",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      false
                        ? _c(
                            "td",
                            [
                              _c("multiselect", {
                                attrs: {
                                  options: _vm.shifts,
                                  "track-by": "title",
                                  label: "title",
                                  noResult: "Смена не найдена",
                                  disabled: _vm.disabled,
                                  "show-labels": false,
                                  placeholder: "Выберите смену",
                                  multiple: true,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateRecord(record.id)
                                  },
                                },
                                model: {
                                  value: _vm.selectedShifts[record.id],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectedShifts, record.id, $$v)
                                  },
                                  expression: "selectedShifts[record.id]",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("multiselect", {
                            attrs: {
                              options: _vm.groups,
                              "track-by": "title",
                              label: "title",
                              noResult: "Группа не найдена",
                              disabled: _vm.disabled,
                              "custom-label": _vm.customLabel,
                              placeholder: "Выберите группу",
                              "select-label": "Выбрать",
                              "deselect-label": "Убрать группу",
                              multiple: true,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateRecord(record.id)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.customLabel(props.option)
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.selectedGroups[record.id],
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedGroups, record.id, $$v)
                              },
                              expression: "selectedGroups[record.id]",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  }),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("SIP аккануты")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("SIP")]),
        _vm._v(" "),
        _c("th", [_vm._v("Пароль")]),
        _vm._v(" "),
        _c("th", [_vm._v("Вн. номер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Пользователь")]),
        _vm._v(" "),
        _c("th", [_vm._v("Группа")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }